export default "__VITE_ASSET__DdxTDUCE__"